import { t } from '@/lib/i18n/messages.js';

export function ResultsEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <svg
        className="mb-4 h-12 w-12 text-[var(--color-qup-text-muted-dark)]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.997 6 18.375m-3.75.125V5.625m0 12.75v-1.5m0-11.25A1.125 1.125 0 014.5 4.5h15a1.125 1.125 0 011.125 1.125M20.625 19.5V5.625m0 13.875a1.125 1.125 0 001.125-1.125m-1.125 1.125h-1.5c-.621 0-1.125-.503-1.125-1.125m0 0v-1.5m0-11.25c0-.621.504-1.125 1.125-1.125"
        />
      </svg>
      <p className="text-sm font-medium text-[var(--color-qup-text-dark)]">
        {t('report.no_results')}
      </p>
      <p className="mt-1 text-xs text-[var(--color-qup-text-muted-dark)]">
        {t('report.no_results_desc')}
      </p>
    </div>
  );
}
